import 'normalize.css';
import "react-datepicker/dist/react-datepicker.css";
import './scss/general.scss';

import React from 'react';
import ReactDOM from 'react-dom';
import {createStore, combineReducers, applyMiddleware} from 'redux';
import thunkMiddleware from 'redux-thunk'
import {browserHistory} from 'react-router';
import {syncHistoryWithStore, routerReducer, routerMiddleware} from 'react-router-redux';
import {AppContainer} from 'react-hot-loader';
import Root from './Root/Root';

import * as reducers from 'store/reducers';

const reducer = combineReducers({
    ...reducers,
    routing: routerReducer
});

const store = createStore(
    reducer,
    window.__REDUX_DEVTOOLS_EXTENSION__ && window.__REDUX_DEVTOOLS_EXTENSION__(),
    applyMiddleware(
        thunkMiddleware,
        routerMiddleware(browserHistory)
    )
);

let history = syncHistoryWithStore(browserHistory, store);

const rootEl = document.getElementById('root');

ReactDOM.render(
    <AppContainer>
        <Root store={store} history={history}/>
    </AppContainer>,
    rootEl
);

if (module.hot) {
    module.hot.accept('./Root/Root', () => {
        const NextRoot = require('./Root/Root').default; // eslint-disable-line global-require
        ReactDOM.render(
            <AppContainer>
                <NextRoot store={store} history={history} />
            </AppContainer>,
            rootEl
        );
    });
}



// WEBPACK FOOTER //
// ./src/index.js